var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFranceCulture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#792C87;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 152.3,
    width: 419.4,
    height: 419.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.8,465l18.5-1.4l0,27.4l15.6,0c9.8,0,19,2.8,19.9,14.8c0.7,9.1-5,15.1-10.1,16.1c-6.2,0-4.4,0-12.6,0 c2.7,0,10.8-5,9-11.9c-1.7-6.3-7.3-6.4-12.5-6.8c-5.3-0.3-27.5-1.5-27.5-1.5L132.8,465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,498.4c-3.4,4.1-6.7,10.3-4.8,17.2c5.8,19.4,36.7,28,49.6,28.5l-1.5-22.7c0,0-21.1,2.8-31.8-8.4 c-4.5-4.7-3.6-9.7-0.2-14C114.8,498.7,110.1,498.5,107.4,498.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 71.6,
    className: "st1",
    width: 419.4,
    height: 419.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.6,388.6h-9.3v-24.1h-3.7v-7.2h3.7c0-2.8-0.1-6.1,1.5-8.5c2.1-3.2,6.4-4.5,10.1-4.2l4.3,0.4v7.1l-3.2-0.2 c-3.4-0.2-3.4,2-3.4,4.7v0.7h5.7v7.2h-5.7V388.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.6,356.5v6h0.1c0.9-3.4,2.8-7,6.9-6.6l1.6,0.1v9.3c-7.1-0.4-8,5.4-8,11.1v12.3h-9.3v-32.1H411.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M442.1,388.6c-0.4-1.6-0.5-3.4-0.4-5c-2.7,3.8-5.4,5.6-10.2,5.6c-5.7,0-10.1-3-10.1-9.1c0-4.7,3-8,7.2-9.6 c3.7-1.4,8.8-1.7,12.7-2v-0.8c0-1.4,0.1-3-0.8-4.2c-0.8-1.1-2.4-1.5-3.8-1.5c-3,0-5.6,1.5-5.6,4.7l-8.8-0.8 c0.9-7.8,8.5-10.1,15.3-10.1c3.3,0,7.6,0.8,10.2,2.9c3.3,2.7,3,6.2,3,10.1v15c0,1.6,0.1,3.2,0.6,4.8H442.1z M441.2,373.3 c-3.5,0.4-10.1,1.2-10.1,5.9c0,2.5,1.5,4.2,4.1,4.2c1.9,0,3.6-1,4.7-2.7c1.3-2,1.3-3.9,1.3-6.2V373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.3,356.5v5.4h0.1c1.9-4.1,4.6-6.1,9.2-6.1c3,0,6,0.9,7.9,3.5c1.8,2.4,1.8,6.5,1.8,9.4v19.9H474v-17.3 c0-3.3,0.4-8.1-4.2-8.1c-1.6,0-3.2,0.9-3.9,2.4c-0.9,1.8-1.1,3.7-1.1,5.7v17.3h-9.3v-32.1H464.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.6,368.7c0-2.9-1.5-5.8-4.9-5.8c-5.1,0-5.8,5.1-5.8,9.2c0,3.9,0.1,9.5,5.4,9.5c3.3,0,4.9-2.6,5.2-5.6 l8.9,0.5c-0.8,8-6.8,12.7-14.6,12.7c-9.7,0-15.5-6.9-15.5-16.4c0-9.9,5.9-17,16.1-17c7.5,0,13.4,4.8,14,12.3L507.6,368.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M528.4,374.2l-0.1,1.6c0,3.8,2.2,6.9,6.2,6.9c2.8,0,5.7-2.1,5.7-5.1l8.6,0.6c0,1.6-3.7,11.1-14.6,11.1 c-9.6,0-15.9-6.7-15.9-16.2c0-9.5,5.6-17.1,15.6-17.1c4.5,0,9.1,2,11.8,5.7c2.7,3.7,3.4,8.2,3.3,12.6H528.4z M539.8,368.7 c-0.2-3.5-1.3-6.7-5.4-6.7c-4.1,0-5.7,3-6,6.7H539.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.3,429.6c0-6-3.1-11.9-10.1-11.9c-10.6,0-11.9,10.5-11.9,19c0,8.1,0.1,19.6,11.1,19.6 c6.8,0,10.2-5.4,10.9-11.5l18.3,1c-1.6,16.5-14,26.3-30.2,26.3c-20.1,0-32-14.3-32-33.9c0-20.4,12.3-35.2,33.2-35.2 c15.4,0,27.7,9.9,29,25.5L216.3,429.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.9,470.8v-11.4h-0.3c-3.1,8.4-9.9,12.7-19,12.7c-6.7,0-12.4-1.4-16.2-7.5c-3.7-5.8-3.3-12-3.3-18.4v-41.8 h19.2v41.8c0,5.4,0.5,10.5,7.3,10.5c4.3,0,8-2.5,9.7-6.4c1.3-3,1.1-6.8,1.1-10.2v-35.7h19.2v66.4H279.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 381.1,
    className: "st0",
    width: 19.2,
    height: 89.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.9,419.6v-15.3h11.6l1.7-19.5l16.7-1.3v20.8h14.3v15.3h-14.3V446c0,7.7,0,10.9,9.3,10.5l6-0.3v14.5 l-1.3,0.3c-3.7,0.5-7.2,1.2-10.7,1.2c-5.5,0-12.8-0.8-17.1-4.3c-5.4-4.4-5.4-12.4-5.4-19v-29.3H332.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423,470.8v-11.4h-0.3c-3.1,8.4-9.9,12.7-19,12.7c-6.7,0-12.4-1.4-16.2-7.5c-3.7-5.8-3.3-12-3.3-18.4v-41.8 h19.2v41.8c0,5.4,0.5,10.5,7.3,10.5c4.3,0,8-2.5,9.7-6.4c1.3-3,1.1-6.8,1.1-10.2v-35.7h19.2v66.4H423z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468,404.4v12.4h0.3c2-7.1,5.9-14.4,14.3-13.7l3.3,0.3v19.2c-14.6-0.8-16.5,11.1-16.5,22.9v25.4H450v-66.4H468 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.6,440.9l-0.1,3.3c0,7.8,4.5,14.3,12.8,14.3c5.9,0,11.8-4.3,11.8-10.5l17.8,1.3c0,3.3-7.7,22.9-30.2,22.9 c-19.9,0-32.8-13.9-32.8-33.6c0-19.6,11.6-35.4,32.3-35.4c9.3,0,18.8,4.2,24.3,11.8c5.5,7.6,6.9,17,6.8,26H510.6z M534,429.5 c-0.4-7.2-2.7-13.9-11.1-13.9c-8.5,0-11.8,6.3-12.4,13.9H534z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceCulture);
export default __webpack_public_path__ + "static/media/france-culture.ede64dd6f6fb5d4277e95fb3373a76e3.svg";
export { ForwardRef as ReactComponent };